import { useMemo } from 'react';

export const useWoburnRows = (data) =>
  useMemo(() => {
    return Object.entries(data).map(([key, value]) => {
      const items = value.map((row) => {
        const [shift_date, shift_type, payback_date, status] = row;

        return {
          shift_date,
          shift_type,
          payback_date,
          status,
        };
      });
      return {
        name: key,
        items,
      };
    });
  }, [data]);
